module.exports = __webpack_public_path__ + "static/logo-b452ff8b848d587ed7c074537a53ce4f.svg";